import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="tw-flex tw-justify-end tw-mt-2">
      <small>&copy; Pebsteel Portal. All Rights Reserved | <Link to="/privacy-policy">Privacy Policy</Link></small>
    </div>
  );
};

export default PrivacyPolicy;
